"use client";

import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

/**
 * Live citation generator embedded on the Image & Photograph landing page. Images rarely
 * expose fetchable, keyless metadata to auto-resolve from a URL, so the tool opens straight
 * on the manual-entry tab preset to the "Image / Photograph" source type (CSL `graphic`).
 * Users type the title, creator, format/medium (which drives the bracketed "[Photograph]"
 * descriptor), year, source, and URL and pick any of the 10,834 styles — no engine change.
 */
export default function ImageCitationGeneratorWidget() {
  return (
    <CitationTool
      initialManualType="graphic"
      initialMode="manual"
      styles={getFeaturedStyles()}
    />
  );
}
